var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { notification } from 'antd';
import classNames from 'classnames';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as helperActions } from '../../../Slice/HelperSlice';
import { certificationFlag, classnameFlag, companyId, getContainerEle, groupId, notificationMessage, protipFlag, rightPlacementFlag, showWarning, accountPlanFlag, selectClassName, } from '../../../Selector/HelperSelector';
import { useNavigate } from 'react-router-dom';
import { GROUP_DETAIL_ROUTE, } from '../../../Utils/Constants';
var ToasterNotification = function ToasterNotification() {
    var _a;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var groupid = useSelector(groupId);
    var companyid = (_a = useSelector(companyId)) !== null && _a !== void 0 ? _a : 0;
    var classNameFlag = useSelector(classnameFlag);
    var showWarningFlag = useSelector(showWarning);
    var rightplacementFlag = useSelector(rightPlacementFlag);
    var proTipFlag = useSelector(protipFlag);
    var toasterMessage = useSelector(notificationMessage);
    var certification = useSelector(certificationFlag);
    var accountplanFlag = useSelector(accountPlanFlag);
    var getContainerElement = useSelector(getContainerEle);
    var className = useSelector(selectClassName);
    var onClickNotification = function () {
        if (groupid !== 0) {
            navigate("".concat(GROUP_DETAIL_ROUTE).concat(groupid));
            notification.destroy();
        }
    };
    var toaster = function () {
        return _jsx("span", { children: toasterMessage });
    };
    notification.config({
        top: 80,
    });
    useEffect(function () {
        if (toasterMessage !== '') {
            notification.destroy();
            notification.open(__assign(__assign(__assign(__assign(__assign({}, (certification && { duration: 20 })), (accountplanFlag && { duration: 50 })), (companyid && { duration: 10 })), (getContainerElement && {
                getContainer: function () { return document.querySelector(".".concat(getContainerElement)) || document.body; },
            })), { className: classNames(className, { successNotification: classNameFlag }, { errorNotification: !classNameFlag }, { warningNotification: classNameFlag && showWarningFlag }, { centerMessage: !rightplacementFlag }, { centerMessageCompany: proTipFlag }, { moreWidth: companyid }), message: toaster(), onClose: function () { return dispatch(helperActions.setNotification({
                    message: '', proTip: false, rightPlacement: false, groupId: 0, classnameFlag: false, className: '',
                })); }, onClick: function () { return onClickNotification(); } }));
        }
    }, [toasterMessage]);
    return (_jsx(_Fragment, {}));
};
export default ToasterNotification;
